import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuestionBubbleIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "17",
    rx: "2"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5,18v3.5a.5.5,0,0,0,.85.35L9,18Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.23,15.72a.76.76,0,0,1,0-1.51.76.76,0,0,1,0,1.51ZM13,12.34h0a.75.75,0,0,1-1.5,0h0c0-2.43,2.24-2.24,2.24-3.75a1.5,1.5,0,0,0-3,0h0a.75.75,0,0,1-1.49,0h0a3,3,0,0,1,6,0C15.22,10.46,13,10.65,13,12.34Z",
    fill: "#fff"
  })]
}), 'QuestionBubbleIcon');